'use strict';

function limitThumbnailSize(size, maxSize, mode) {
  size = {
    width: size.width,
    height: size.height
  };

  var scale;

  switch (mode) {
  case 'preview':
    if (size.width && size.width > maxSize.width) {
      scale = maxSize.width / size.width;

      size.width *= scale;
      if (size.height) {
        size.height *= scale;
      }
    }

    if (size.height && size.height > maxSize.height) {
      scale = maxSize.height / size.height;

      size.height *= scale;
      if (size.width) {
        size.width *= scale;
      }
    }
    break;

  case 'scale_crop':
    // Empty height or width make no sense for scale_crop, assume square
    size.width = size.width || size.height;
    size.height = size.height || size.width;

    if (size.width > maxSize.width && size.height > maxSize.height) {
      scale = Math.max(
        maxSize.width / size.width,
        maxSize.height / size.height
      );

      size.width *= scale;
      size.height *= scale;
    }
    break;

  default:
    throw new Error('Unknown image mode');
  }

  if (size.width) {
    size.width = Math.round(size.width);
  }

  if (size.height) {
    size.height = Math.round(size.height);
  }

  return size;
}

module.exports = limitThumbnailSize;


/** WEBPACK FOOTER **
 ** ./utils/limitThumbnailSize.js
 **/